<template>
  <div class="config mb-2">
    <img
      class="setting"
      src="@/assets/images/setting_icon.svg"
      @click="settingClick"
      v-if="isConfigured && showSetting"
    />
    <div class="logo-box">
      <img class="large-icon" :src="imgSrc" />
    </div>
    <div>
      <h4>{{ name.toUpperCase() }}</h4>
      <p class="details-text">
        {{ detailsText }}
      </p>
    </div>
    <hr />
    <div class="bottom-box pt-2 pb-2">
      <b-row>
        <b-col class="text-center">
          <b-button
            variant="primary"
            disabled
            class="config-btn configured"
            v-if="isConfigured"
            >Configured</b-button
          >
          <b-button
            variant="primary"
            class="config-btn"
            @click="Configure"
            v-else
            >Configure</b-button
          >
        </b-col>
        <b-col md="4" v-if="showSwitch" class="flex align-items-center">
          <div class="custom-control custom-switch b-custom-control-lg">
            <b-form-checkbox
              v-model="activeVal"
              @change="toogleStatus"
              switch
            ></b-form-checkbox>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: {
      type: String,
    },
    name: {
      type: String,
    },
    detailsText: {
      type: String,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    showSwitch: {
      type: Boolean,
      default: true,
    },
    showSetting: {
      type: Boolean,
      default: true,
    },
    isConfigured: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeVal: false,
    };
  },
  watch: {
    isActive(val) {
      this.activeVal = val;
    },
  },
  methods: {
    toogleStatus(val) {
      this.$emit("toogleSwitch", val);
    },
    settingClick() {
      this.$emit("onClickSetting");
    },
    Configure() {
      this.$emit("onClickConfigure");
    },
  },
  mounted() {
    this.activeVal = this.isActive;
  },
};
</script>

<style scoped>
.config {
  /* width: 250px; */
  border: 1px solid red;
  position: relative;
  padding: 12px;
  border: 1px solid #ececec;
  box-shadow: 0px 0px 7px #e6e6e6;
  border-radius: 10px;
}
.logo-box {
  width: 150px;
  height: 70px;
  margin: auto;
  display: block;
}
.large-icon {
  width: 100%;
  z-index: -9;
}
.setting {
  position: absolute;
  top: 8px;
  right: 8px;
}
.details-text {
  color: black;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  line-clamp: 4;
  min-height: 6rem;
  -webkit-box-orient: vertical;
  min-height: 106px;
}
.bottom-box {
  display: block;
}
::v-deep .switch-primary .switch-input:checked + .switch-slider {
  background-color: #34a853;
  border-color: #34a853;
}
.config-btn {
  border-radius: 6px;
  font-size: 14px;
  padding: 3px 17px;
  box-shadow: none;
}
.configured {
  border: 1px solid #e3e3e3;
  background: #f2f5f9;
  color: #4140e2;
}
</style>
